module.exports = __webpack_public_path__ + "img/9.09d354c6.jpg";